angular.module('edxManage', [
  'EdxManageAdminModule']);
